module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-400.woff2?479970ffb74f2117317f9d24d9e317fe";